import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { axiosPrivate } from '../axios';
import config from '../config';

const NotificationContext = createContext();

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [counts, setCounts] = useState({
    likes: 0,
    mutuals: 0,
    system: 0,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  // Обновление счётчиков (вызывается из компонентов с axiosPrivate)
  const updateCounts = useCallback((data) => {
    // Маппинг ключей: бэкенд возвращает like/mutual (единственное число)
    // но мы используем likes/mutuals (множественное число) на фронте
    const mappedCounts = {
      likes: data.like || 0, // лайки + суперлайки
      mutuals: (data.mutual || 0) + (data.superlike || 0), // взаимные симпатии
      system: data.system || 0,
      total: data.total || 0,
    };
    setCounts(mappedCounts);
  }, []);

  // Обновление счётчика конкретного типа
  const decrementCount = useCallback((type) => {
    setCounts((prev) => ({
      ...prev,
      [type]: Math.max(0, prev[type] - 1),
      total: Math.max(0, prev.total - 1),
    }));
  }, []);

  // Сброс счётчика конкретного типа
  const resetCount = useCallback((type) => {
    setCounts((prev) => {
      const newCounts = { ...prev };
      const oldValue = prev[type] || 0;
      newCounts[type] = 0;
      newCounts.total = Math.max(0, prev.total - oldValue);
      return newCounts;
    });
  }, []);

  const totalCounts = [counts.likes, counts.mutuals, counts.system].reduce((acc, cur) => {
    return (acc += cur);
  });

  const markAsRead = async () => {
    try {
      const response = await axiosPrivate.get(config.API.NOTIFICATIONS.COUNTS);
      updateCounts(response.data.data);
    } catch (err) {
      console.error('Error refreshing counts:', err);
    }
  };

  useEffect(() => {
    markAsRead();
  }, []);

  const value = {
    totalCounts,
    counts,
    loading,
    updateCounts,
    decrementCount,
    resetCount,
    setLoading,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};
